import React from 'react';

export const ArrowsMove = () => (
    <>
        <g transform="translate(-0.5 -0.5) scale(0.6)">
            <path d="M33 16.5L38.5 22M38.5 22L33 27.5M38.5 22H27.5M11 16.5L5.5 22M5.5 22L11 27.5M5.5 22H16.5M16.5 33L22 38.5M22 38.5L27.5 33M22 38.5V27.5M27.5 11L22 5.5M22 5.5L16.5 11M22 5.5V16.5" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
    </>
);